import React from "react";
import cableCat from "../extras/image/cablecat.jpg";
import PropTypes from 'prop-types'


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tieneError: false, mensajeError: "" };
  }

  static getDerivedStateFromError(error) {
    // Método 1
    return { tieneError: true, mensajeError: error.message };
  }



  render() {
    if (this.state.tieneError) {
      // "UI de emergencia"
      return (
        <div style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          textAlign: 'center',
          alignItems: 'center',
          justifyItems: 'center',
        }}>
          <div style={{
            flex: 1,
            alignItems: 'center',
          }}>
            <h1 className="flex flex-1 mt-2 font-bold text-lg mb-1">Se produjo un error</h1>
            <img src={cableCat} />
            <p>Recargue la pagina mientras nuestros ingenieros especializados solucionan el problema</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object
}

export default ErrorBoundary;